import type SvgIcon from 'LuxKit/SvgIcon'
import SolidPlaneDepartureIcon from 'LuxKit/Icons/solid/SolidPlaneDepartureIcon'
import SolidBedIcon from 'LuxKit/Icons/solid/SolidBedIcon'
import SolidShipIcon from 'LuxKit/Icons/solid/SolidShipIcon'
import SolidCompassIcon from 'LuxKit/Icons/solid/SolidCompassIcon'
import SolidCarIcon from 'LuxKit/Icons/solid/SolidCarIcon'
import SolidTicketIcon from 'LuxKit/Icons/solid/SolidTicketIcon'

type VoucherProductType = NonNullable<App.PublicVoucher['productType']>

const VOUCHER_PRODUCT_TYPE_ICON_MAP: Record<VoucherProductType, typeof SvgIcon> = {
  flight: SolidPlaneDepartureIcon,
  hotel: SolidBedIcon,
  cruise: SolidShipIcon,
  tour: SolidCompassIcon,
  carhire: SolidCarIcon,
  generic: SolidTicketIcon,
}

export default function getVoucherProductTypeIcon(productType?: string): typeof SvgIcon {
  if (productType && productType in VOUCHER_PRODUCT_TYPE_ICON_MAP) {
    return VOUCHER_PRODUCT_TYPE_ICON_MAP[productType as VoucherProductType]
  }
  return SolidPlaneDepartureIcon
}
